import { render, staticRenderFns } from "./CurationEmptyDefaultLayout.vue?vue&type=template&id=5aa07188&scoped=true&"
import script from "./CurationEmptyDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./CurationEmptyDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa07188",
  null
  
)

export default component.exports